<template>
  <div id="portal-context">
    <context-picker
      id="main-context-picker"
      title="Group Selected"
      transitionName="slide-fade"
      :closeOnOutsideClick="true"
    />
  </div>
</template>
<script>
  import ContextPicker from '@organisms/ContextPicker'

  export default {
    components: {
      ContextPicker
    }
  }
</script>
